import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faHashtag, faPercentage, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        fecha_factura: '',
        fecha_entrega: '',
        fecha_vencimiento: '',
        estado_factura: '',
        consecutivo_fact: '',
        id_departamento: '',
        id_municipio: '',
        periodo_factura: '',
        cc_vencidas: '',
        valor_factura: '',
        valor_cartera: '',
        observaciones: '',
        departamentosApor: [],
        municipiosApor: [],
        periodos: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { fecha_factura, fecha_entrega, fecha_vencimiento, estado_factura, consecutivo_fact,
                id_departamento, id_municipio, periodo_factura, cc_vencidas, valor_factura, valor_cartera,
                observaciones
            } = this.state;
        var errores = [];
        if (!fecha_factura) { errores.push("error_fecha_factura"); }
        if (!fecha_entrega) { errores.push("error_fecha_entrega"); }
        if (!fecha_vencimiento) { errores.push("error_fecha_vencimiento"); }
        if (!estado_factura) { errores.push("error_estado_factura"); }
        if (!consecutivo_fact) { errores.push("error_consecutivo_fact"); }
        if (!id_departamento) { errores.push("error_id_departamento"); }
        if (!id_municipio) { errores.push("error_id_municipio"); }
        if (!periodo_factura) { errores.push("error_periodo_factura"); }
        if (!cc_vencidas) { errores.push("error_cc_vencidas"); }
        if (!valor_factura) { errores.push("error_valor_factura"); }
        if (!valor_cartera) { errores.push("error_valor_cartera"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            fecha_factura: fecha_factura,
            fecha_entrega: fecha_entrega,
            fecha_vencimiento: fecha_vencimiento,
            estado_factura: estado_factura,
            consecutivo_fact: consecutivo_fact,
            id_departamento: id_departamento,
            id_municipio: id_municipio,
            periodo_factura: periodo_factura,
            cc_vencidas: cc_vencidas,
            valor_factura: valor_factura,
            valor_cartera: valor_cartera,
            observaciones: observaciones,
            id_usuario: window.localStorage.getItem('idusuario')
        }
        Swal.showLoading();
        authAxios.post("fact_aportes/registrar", datosEnviar)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                if (datosRespuesta.data.Status) {
                    Swal.close();
                    Swal.fire(
                        'Facturación Aportes Municipales!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterFactAportesMunicipales");
                } else {
                    Swal.close();
                    Swal.fire(
                        'Facturación Aportes Municipales!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('id_departamento').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, municipiosApor: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    cargarValores() {
        Swal.showLoading();
        var id_departamento = document.getElementById("id_departamento").value;
        var id_municipio = document.getElementById("id_municipio").value;
        authAxios.get("alcaldia/cargar_valores/" + id_departamento + "/" + id_municipio)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    valor_factura: datosRespuesta.data.VALOR_CONCEPTO,
                    valor_cartera: datosRespuesta.data.VALOR_CARTERA,
                    load: ''
                });
                Swal.close();
            })
            .catch(console.log);
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, departamentosApor: datosRespuesta.data.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("fact_aportes/periodos_fact")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, periodos: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("fact_aportes/consecutivo_fact")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true, consecutivo_fact: "CC-" + datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { fecha_factura, fecha_entrega, fecha_vencimiento, estado_factura, consecutivo_fact,
                id_departamento, id_municipio, periodo_factura, cc_vencidas, valor_factura, valor_cartera,
                observaciones,
                periodos, departamentosApor, municipiosApor
            } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE FACTURAS APORTES MUNICIPALES</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_factura">Fecha Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_factura" id="fecha_factura" value={fecha_factura}
                                                            className={((this.verificarError("error_fecha_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA FACTURA" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Factura</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_entrega">Fecha Entrega</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_entrega" id="fecha_entrega" value={fecha_entrega}
                                                            className={((this.verificarError("error_fecha_entrega")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA ENTREGA" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_vencimiento">Fecha Vencimiento</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_vencimiento" id="fecha_vencimiento" value={fecha_vencimiento}
                                                            className={((this.verificarError("error_fecha_vencimiento")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="FECHA VENCIMIENTO" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Entrega</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="periodo_factura">Periodo Factura</label>
                                                    <select name="periodo_factura"
                                                        id="periodo_factura"
                                                        className={((this.verificarError("error_periodo_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cambioValor(e)
                                                            this.crearConsecutivoFact(e);
                                                        }}>
                                                        <option value="">Seleccione el Periodo Factura</option>
                                                        {
                                                            periodos.map((itemPeriodos) => (
                                                                <option key={itemPeriodos.ID_TABLA} value={itemPeriodos.ANO_FACTURA + "" + itemPeriodos.MES_FACTURA}>{itemPeriodos.PERIODO} - {itemPeriodos.ANO_FACTURA}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Periodo Factura</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="estado_factura">Estado Factura</label>
                                                    <select name="estado_factura"
                                                        id="estado_factura"
                                                        className={((this.verificarError("error_estado_factura")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado Factura</option>
                                                        <option value="1">ENTREGADO</option>
                                                        <option value="2">PENDIENTE DE ENVÍO</option>
                                                        <option value="3">RECLAMADA</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado Factura</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN MUNICIPIO</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className='col-md-3'>
                                                    <label htmlFor="id_departamento">Departamento</label>
                                                    <select name="id_departamento"
                                                        id="id_departamento"
                                                        className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={e => {
                                                            this.cargarMunicipios(e);
                                                            this.cambioValor(e)
                                                        }}>
                                                        <option value="">Seleccione el Departamento</option>
                                                        {
                                                            departamentosApor.map((itemDepartamentosApor) => (
                                                                <option key={itemDepartamentosApor.ID_TABLA} value={itemDepartamentosApor.ID_DEPARTAMENTO}>{itemDepartamentosApor.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                </div>
                                                <div className='col-md-3'>
                                                    <label htmlFor="id_municipio">Municipio</label>
                                                    <select name="id_municipio"
                                                        id="id_municipio"
                                                        className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={(e) => {
                                                            this.cambioValor(e);
                                                            this.cargarValores(e);
                                                        }}>
                                                        <option value="">Seleccione el Municipio</option>
                                                        {
                                                            municipiosApor.map((itemMunicipiosApor) => (
                                                                <option key={itemMunicipiosApor.ID_TABLA} value={itemMunicipiosApor.ID_MUNICIPIO}>{itemMunicipiosApor.NOMBRE}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN VALORES FACTURA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-2">
                                                    <label htmlFor="consecutivo_fact">Consecutivo Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="consecutivo_fact" id="consecutivo_fact" value={consecutivo_fact}
                                                            className={((this.verificarError("error_consecutivo_fact")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Consecutivo Fact." aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Consecutivo Factura</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className="row g-3">
                                                <div className="col-md-2">
                                                    <label htmlFor="cc_vencidas">C.C. Vencidas</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="cc_vencidas" id="cc_vencidas" value={cc_vencidas}
                                                            className={((this.verificarError("error_cc_vencidas")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="C.C. Vencidas" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite las C.C. Vencidas</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_factura">Valor Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_factura" id="valor_factura" value={valor_factura}
                                                            className={((this.verificarError("error_valor_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Factura" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Factura</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="valor_cartera">Valor Cartera</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="valor_cartera" id="valor_cartera" value={valor_cartera}
                                                            className={((this.verificarError("error_valor_cartera")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Cartera" aria-describedby="helpId"
                                                            onChange={this.cambioValor}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Digite el Valor Cartera</small>
                                                </div>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-12">
                                                    <label htmlFor="observaciones">Observaciones</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} className='form-control form-control-sm' id="observaciones" name="observaciones" rows='3' onChange={this.cambioValor} aria-describedby="helpId"></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite las Observaciones</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Fact. Aportes Munc.</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={"/MasterFactAportesMunicipales"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;